import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActionErrorKey } from "../../../helpers/actionError";
import { errorStatusEntered } from "../connection";

const prefix = "app/error-toast";

type State = {
  // Translation key in the "translation" namespace, null when hidden.
  messageKey: ActionErrorKey | null;
};

const initialState: State = {
  messageKey: null,
};

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    errorToastShown: (state, action: PayloadAction<ActionErrorKey>) => {
      state.messageKey = action.payload;
    },
    errorToastDismissed: (state) => {
      state.messageKey = null;
    },
  },
  extraReducers: (builder) => {
    // Everything that raises the footer error banner raises the toast too, so
    // the toast can fully replace the banner (see ErrorToast / Footer).
    builder.addCase(errorStatusEntered, (state) => {
      state.messageKey = "technicalError";
    });
  },
});

export default slice.reducer;
export const { errorToastShown, errorToastDismissed } = slice.actions;
